module.exports = __webpack_public_path__ + "img/hs-logo.4d57b136.png";